interface ElementDefinition {
  name: string;
  description: string;
  examples: string[];
  priority: number;
}

export const websiteElements: ElementDefinition[] = [
  {
    name: "Main Hero Headline",
    description: "The primary headline in the hero section, typically the first and largest text users see",
    examples: [
      "Transform Your Website Copy in Minutes",
      "Boost Your Conversion Rate Today"
    ],
    priority: 1
  },
  {
    name: "Hero Subheadline",
    description: "Supporting text under the main hero headline that provides additional context",
    examples: [
      "AI-powered copy analysis to increase your conversion rates",
      "Get detailed insights and recommendations in seconds"
    ],
    priority: 2
  },
  {
    name: "Primary CTA Button",
    description: "Main call-to-action button, usually prominently displayed in the hero section",
    examples: [
      "Get Started Free",
      "Analyze My Website"
    ],
    priority: 3
  },
  {
    name: "Navigation Menu Items",
    description: "Text links in the header navigation menu",
    examples: [
      "About",
      "Features",
      "Pricing"
    ],
    priority: 4
  },
  {
    name: "Feature Headlines",
    description: "Headlines introducing specific features or benefits",
    examples: [
      "AI-Powered Analysis",
      "Real-Time Results"
    ],
    priority: 5
  },
  {
    name: "Feature Descriptions",
    description: "Detailed text explaining features or benefits",
    examples: [
      "Our advanced AI analyzes your copy in seconds",
      "Get detailed recommendations for improvement"
    ],
    priority: 6
  },
  {
    name: "Social Proof Headlines",
    description: "Headlines in testimonials or social proof sections",
    examples: [
      "Trusted by 10,000+ Businesses",
      "What Our Customers Say"
    ],
    priority: 7
  },
  {
    name: "Secondary CTAs",
    description: "Call-to-action buttons outside the hero section",
    examples: [
      "Learn More",
      "See How It Works"
    ],
    priority: 8
  }
];

export function generatePrompt(text: string): string {
  const elementInstructions = websiteElements
    .sort((a, b) => a.priority - b.priority)
    .map(element => (
      `${element.name}:
- Description: ${element.description}
- Examples: ${element.examples.join(', ')}
- Look for text that serves this purpose and analyze its effectiveness`
    ))
    .join('\n\n');

  return `You are an expert copywriting analyst specializing in conversion rate optimization. 
Analyze the following website elements in order of priority. For each element, provide specific, actionable solutions in quotes.
IMPORTANT: Never analyze the same piece of text twice - each Current State must be unique.

${elementInstructions}

For each issue found, use this exact format:
Category: [element name from the list above]
Title: [clear issue title]
Current State: [exact problematic copy - must be unique, never repeat the same text]
Importance: [brief explanation of conversion impact, max 200 chars]
Solution: Change to "[specific new copy]"

Provide exactly 17 issues, focusing on the most critical problems first. Each Current State must be unique - never analyze the same text twice.
Separate each issue with two newlines.

Website copy to analyze: ${text}`;
}